import { useEffect, useRef, useState } from 'react';
import ImagenBannerCUETARA from '../../assets/images/CUETARA.jpg';
import './CUETARA.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function CUETARA() {

    
  return (
    <>
    
    {/* Bloque de inicio de caso CUETARA */}
    <div className="infra-banner-CUETARA">
      {/* Imagen inicio de caso CUETARA */}
  <img src={ImagenBannerCUETARA} alt="CUETARA" className="banner-img-CUETARA" />
  {/*Titulo de caso CUETARA Inicio  */}
    <h1 className="banner-texto-CUETARA">CUETARA</h1>
</div>
{/* Bloque de inicio info de caso CUETARA */}
<div className="fondo-blanco-CUETARA">
<div className="contenedor-CUETARA">
  <div className="columna-izquierda-CUETARA">
    {/* Bloque Izquierdo de caso CUETARA*/}
     <h1>SECTOR:</h1>
    <p>ALIMENTARIO</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
      <p>Cuétara es una empresa mexicana con más de 85 años de trayectoria en el sector alimentario, dedicada a la elaboración de galletas, cereales y productos horneados de alta calidad. Su compromiso con la innovación, el sabor y la nutrición la ha convertido en una marca líder y reconocida en todo el país. Con un enfoque en la excelencia operativa y altos estándares de producción, Cuétara forma parte esencial de la vida diaria de millones de familias mexicanas.<br>
      </br>
      <br></br>
      Gracias a su infraestructura sólida, sus alianzas comerciales y su capacidad de producción a gran escala, Cuétara se posiciona como un referente en la industria alimentaria nacional. Su expansión estratégica, presencia en múltiples canales de distribución, y apuesta por el desarrollo sustentable la consolidan como una empresa de impacto que impulsa el crecimiento económico y social de México.
    </p>
    <div className="boton-reto-CUETARA">
      <a href="https://gcuetara.com.mx/" className="btn-reto-CUETARA">Ver más información</a>
    </div>
  </div>

  <div className="columna-derecha-CUETARA">
    {/* Bloque Derecho de caso CUETARA */}
    <h2>RETO DEL PROYECTO: FACTURACIÓN ELECTRÓNICA EN GRUPO CUÉTARA</h2>
    <p>Debido al crecimiento exponencial en el volumen de transacciones de facturación electrónica entre las empresas del Grupo Cuétara, la organización enfrenta el desafío de asegurar la continuidad y eficiencia del proceso mediante la selección de un Proveedor Autorizado de Certificación (PAC) que cumpla con altos estándares de agilidad, precisión y calidad en la validación de documentos.<br></br>
Este reto implica garantizar que la infraestructura tecnológica y los flujos operativos internos estén alineados con un servicio de certificación capaz de responder a las exigencias del grupo en términos de volumen, velocidad y confiabilidad.
</p>

    <h2>SOLUCIÓN IMPLEMENTADA: MODERNIZACIÓN DEL PROCESO DE CERTIFICACIÓN DOCUMENTAL EN GRUPO CUÉTARA.</h2>
    <p>Como parte de nuestro servicio de asesoría fiscal y tecnológica, se ejecutó un levantamiento integral del proceso de certificación empleado por el cliente. A partir de este análisis, se definió e implementó una transición tecnológica del protocolo de intercambio FTP hacia una arquitectura basada en Web Services, con el objetivo de optimizar la interoperabilidad, fortalecer la seguridad y elevar la eficiencia en la transmisión de información entre sistemas.<br></br>
Esta modernización permitió integrar de forma eficaz nuestro sistema IAutomatiza CFDI Cloud, lo que se tradujo en los siguientes beneficios:<br></br>
<br></br>
•	Disminución significativa de los tiempos de certificación de documentos fiscales.<br></br>
•	Mayor seguridad y confiabilidad en los procesos de timbrado.<br></br>
•	Mejora en la trazabilidad y control de los documentos electrónicos.<br></br>
•	Infraestructura más ágil y escalable, adaptable a futuras exigencias operativas.<br></br>
<br></br>
La solución fortaleció la gestión documental del cliente, alineando los procesos de facturación electrónica con los estándares tecnológicos actuales y las necesidades dinámicas del grupo empresarial.
</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default CUETARA;